/**
 * Theme-side gift auto-add (matches Andac's expected flow):
 * - 2 paid products → Free Necklace Gift
 * - 3 paid products → Mystery Gift
 *
 * Used because EG rules are currently empty and AMP tiers are order_discount only.
 * Safe: skips if gift already in cart; ignores gift lines when counting.
 */
(function () {
  var NECKLACE = {
    id: 46965140717809,
    handle: 'free-necklace-gift',
    key: 'necklace',
  };
  var MYSTERY = {
    id: 46965166899441,
    handle: 'mystery-gift',
    key: 'mystery',
  };
  var THRESHOLD_NECKLACE = 2;
  var THRESHOLD_MYSTERY = 3;
  var busy = false;
  var lastRun = 0;

  function isGiftLine(item) {
    if (!item) return false;
    var handle = (item.handle || '').toLowerCase();
    if (handle === NECKLACE.handle || handle === MYSTERY.handle) return true;
    if (item.properties && (item.properties._aur_auto_gift || item.properties._eg_gift)) return true;
    var title = (item.product_title || item.title || '').toLowerCase();
    if ((item.final_price === 0 || item.price === 0) && /hediye|gift|kolye|necklace|mystery|gizemli/.test(title)) {
      return true;
    }
    return false;
  }

  function paidCount(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.filter(function (item) {
      return !isGiftLine(item);
    }).length;
  }

  function hasGift(cart, gift) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return (
        item.id === gift.id ||
        item.variant_id === gift.id ||
        (item.handle || '').toLowerCase() === gift.handle ||
        (item.properties && item.properties._aur_auto_gift === gift.key)
      );
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function addGift(gift) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [
          {
            id: gift.id,
            quantity: 1,
            properties: {
              _aur_auto_gift: gift.key,
            },
          },
        ],
      }),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error((data && data.description) || 'gift add failed');
        return data;
      });
    });
  }

  function refreshAmp() {
    try {
      if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
      else if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
      else if (typeof window.SLIDECART_SET_CART === 'function') {
        fetchCart().then(function (cart) {
          window.SLIDECART_SET_CART(cart);
        });
      }
    } catch (e) {}
  }

  function syncGifts() {
    var now = Date.now();
    if (busy || now - lastRun < 600) return Promise.resolve(false);
    busy = true;
    lastRun = now;

    return fetchCart()
      .then(function (cart) {
        var count = paidCount(cart);
        var chain = Promise.resolve();
        var added = false;

        if (count >= THRESHOLD_NECKLACE && !hasGift(cart, NECKLACE)) {
          chain = chain.then(function () {
            return addGift(NECKLACE).then(function () {
              added = true;
            });
          });
        }

        chain = chain.then(function () {
          return fetchCart();
        }).then(function (cart2) {
          var count2 = paidCount(cart2);
          if (count2 >= THRESHOLD_MYSTERY && !hasGift(cart2, MYSTERY)) {
            return addGift(MYSTERY).then(function () {
              added = true;
            });
          }
        });

        return chain.then(function () {
          return added;
        });
      })
      .then(function (added) {
        if (added) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'aur-gift-auto-add' } }));
          setTimeout(refreshAmp, 150);
          setTimeout(refreshAmp, 500);
        }
        return added;
      })
      .catch(function (err) {
        console.warn('[aur-gift-auto-add]', err);
        return false;
      })
      .finally(function () {
        busy = false;
      });
  }

  // After any cart/add.js from the storefront, sync gifts
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      return nativeFetch.apply(this, args).then(function (response) {
        if (url && /\/cart\/(add|change|update|clear)(\.js)?/i.test(url)) {
          setTimeout(function () {
            syncGifts();
          }, 250);
        }
        return response;
      });
    };
  }

  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.source === 'aur-gift-auto-add') return;
    setTimeout(syncGifts, 300);
  });

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(syncGifts, 800);
  });

  // Expose for manual retry / AMP bridge
  window.AUR_SYNC_GIFTS = syncGifts;
})();
